module.exports = __webpack_public_path__ + "img/feature-01.0ab647cb.png";